/**
 * Auth Particles
 * Initializes particles.js background effect for authentication pages
 */

/**
 * Particle configuration for authentication pages
 * @type {Object}
 */
const particlesConfig = {
    particles: {
        number: {
            value: 80,
            density: {
                enable: true,
                value_area: 800
            }
        },
        color: {
            value: "#ff4c4c"
        },
        shape: {
            type: "circle"
        },
        opacity: {
            value: 0.3,
            random: true
        },
        size: {
            value: 3,
            random: true
        },
        line_linked: {
            enable: true,
            distance: 150,
            color: "#ff4c4c",
            opacity: 0.2,
            width: 1
        },
        move: {
            enable: true,
            speed: 2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false
        }
    },
    interactivity: {
        detect_on: "canvas",
        events: {
            onhover: {
                enable: true,
                mode: "repulse"
            },
            onclick: {
                enable: true,
                mode: "push"
            },
            resize: true
        },
        modes: {
            repulse: {
                distance: 100,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            }
        }
    },
    retina_detect: true
};

/**
 * Initialize particles.js on authentication pages
 */
export function initAuthParticles() {
    const particlesContainer = document.getElementById('particles-js');

    if (!particlesContainer) {
        return;
    }

    // Check if particlesJS is loaded
    if (typeof particlesJS === 'undefined') {
        console.warn('particlesJS library not loaded');
        return;
    }

    // Initialize particles
    particlesJS('particles-js', particlesConfig);
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAuthParticles);
} else {
    initAuthParticles();
}
